import React, {useContext} from 'react';

// components
import Page from '../../components/Page';

//contexts
import TextsContext from "../../contexts/Texts";

const DefaultPage = () => {

  const { strona_nie_istnieje } = useContext(TextsContext);

	return (
		<Page>
			<h2>404</h2>
			<h3>{strona_nie_istnieje}</h3>
		</Page>
	);
};

export default DefaultPage;